import { IAppState } from '../../../../../AppModulesWrapper';
import { IPackage } from '../types';

export const selectPackages = (state: IAppState): IPackage[] => {
  return state.servicePickerWidgetV2.publicationPackages.packagesList;
};
